import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tv, Radio, Facebook } from "lucide-react";
import { API, IMAGES } from "@/config";
import LiveChat from "@/components/LiveChat";
import SportsTicker from "@/components/SportsTicker";

export default function LivePage() {
  const [settings, setSettings] = useState(null);
  
  useEffect(() => {
    fetchSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-only fetch
  
  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/settings`);
      setSettings(res.data);
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };
  
  const getEmbedUrl = (url) => {
    if (!url) return null;
    if (url.includes('ok.ru/video/')) {
      const videoId = url.split('ok.ru/video/')[1]?.split('?')[0];
      return `https://ok.ru/videoembed/${videoId}`;
    }
    if (url.includes('ok.ru/videoembed/')) {
      return url;
    }
    return url;
  };
  
  const streamUrl = settings?.stream_url ? getEmbedUrl(settings.stream_url) : null;
  
  return (
    <div className="live-page">
      {/* Sports Ticker */}
      <SportsTicker />
      
      <section className="container" style={{ padding: '2rem 1rem' }}>
        <div className="section-header">
          <h1 className="section-title" style={{ fontSize: '2rem' }}>
            <span className="live-indicator"><span className="live-dot"></span> LIVE</span>
            {settings?.stream_title || "Game Day Stream"}
          </h1>
        </div>
        
        <div className="live-stream-layout">
          <div className="live-player-section">
            <div className="live-player-container">
              <div className="live-player-wrapper">
                {streamUrl && settings?.stream_active ? (
                  <iframe
                    src={streamUrl}
                    allowFullScreen
                    allow="autoplay"
                    title="Live Stream"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                  />
                ) : (
                  <div className="live-player-placeholder" style={{ backgroundImage: `url('${IMAGES.watchLivePlaceholder}')`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                    <h3 style={{ textShadow: '0 2px 10px rgba(0,0,0,0.8)' }}>{settings?.stream_title || "Live Stream"}</h3>
                    <p style={{ textShadow: '0 2px 10px rgba(0,0,0,0.8)' }}>Check back during game time</p>
                    <p className="live-note">We do not host the live streams and cannot guarantee quality. We only provide ways to watch them.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="live-chat-section">
            <LiveChat />
          </div>
        </div>
      </section>
      
      <section className="container" style={{ padding: '2rem 1rem' }}>
        <div className="radio-card">
          <div className="radio-icon">
            <Radio size={48} />
          </div>
          <div className="radio-content">
            <h3>UK Radio Broadcast</h3>
            <p>Catch the Radio Broadcast of UK Games, Pre-Game and Post Game Shows</p>
            <a href="https://www.iheart.com/live/newsradio-630-wlap-965" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              <Radio size={16} />
              Listen on iHeart Radio
            </a>
          </div>
        </div>
      </section>
      
      <section className="container" style={{ padding: '2rem 1rem 4rem' }}>
        <div className="facebook-card-large">
          <Facebook size={48} />
          <h3>Join The Funchester TV Facebook Group</h3>
          <p>Get news, updates, and discussion about Kentucky sports and upcoming streams!</p>
          <a href="https://www.facebook.com/groups/979251609124467" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            <Facebook size={16} />
            Join Facebook Group
          </a>
        </div>
      </section>
    </div>
  );
}
